import React,{useState} from 'react';
import EmployAside from "../aside";
import MesAchatsIndex from "./mes_achats";
import AchatCreate from './achatCreate';

const CreateAchat = () => {
  const [isOpenSidebar,setIsOpenSidebar] = useState(false);
  return (    
    <div className="main-page-wrapper">
    <EmployAside isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar} />

    <AchatCreate setIsOpenSidebar={setIsOpenSidebar} />
    </div>    
  );
};

export default CreateAchat;
